import { BaseBlock } from "./BaseBlock";

type Product = {

    title: string;

};

export class ProductHeaderBlock extends BaseBlock {

    private readonly product: Product;

    private root!: HTMLElement;

    constructor(
        product: Product
    ) {

        super();

        this.product = product;

    }

    public override mount(): void {

        this.root =
            document.createElement("h3");

        this.root.textContent =
            this.product.title;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}